import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  OtpInputComponent,
  TwoFactorAuthenticationDialogComponent,
  TwoFactorAuthenticationGenerateComponent,
  TwoFactorAuthenticationNotificationComponent,
  TwoFactorAuthenticationResetComponent
} from './components/two-factor-authentication-dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ImageWithTextComponent } from './components/image-with-text.component';
import { ImageWithLinkComponent } from './components/image-with-link.component';
import { OtpQrCodeComponent } from './components/otp-qrcode/otp-qrcode.component';
import { QrCodeModule } from 'ng-qrcode';
import { SelectChapterDialogComponent } from './dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

const COMPONENTs = [
  TwoFactorAuthenticationDialogComponent,
  TwoFactorAuthenticationResetComponent,
  TwoFactorAuthenticationGenerateComponent,
  TwoFactorAuthenticationNotificationComponent,
  ImageWithTextComponent,
  ImageWithLinkComponent,
  OtpQrCodeComponent,
  SelectChapterDialogComponent,
  OtpInputComponent,
];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    QrCodeModule,
    FormsModule,
    ReactiveFormsModule,
    NgbTooltip
  ],
  declarations: [...COMPONENTs],
  exports: [...COMPONENTs]
})
export class PtCoreModule {
}
